export const USE_CARD_OPTIONS = {
  creditCardId: {
    key: "creditCardId", //not creditCard to keep it consistent with BE key
    label: "Credit Card",
  },
  newCreditCard: {
    key: "newCreditCard",
    label: "New Credit Card",
  },
};

export const CC_TYPES = {
  visa: "visa",
  mastercard: "master",
  amex: "amex",
  jcb: "jcb",
  discover: "discover",
  diners: "diners",
};
